(function () {

document.documentElement.classList.add("tw-js");
document.addEventListener("DOMContentLoaded", function() {
    var blocksToAnimate = document.querySelectorAll(".tw-block-animation");
    if (!blocksToAnimate.length) return;
    if (!("IntersectionObserver" in window)) {
        document.documentElement.classList.add("tw-io-disabled");
        for(var i = 0; i < blocksToAnimate.length; i++)blocksToAnimate[i].classList.add("animated");
        return;
    }
    var options = {
        rootMargin: "0px 0px -80px 0px",
        threshold: 0
    };
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add("animated");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    for(var i = 0; i < blocksToAnimate.length; i++)observer.observe(blocksToAnimate[i]);
});


(function($) {
    $(document).ready(function() {
        const sections = $("section[id]");
        const navLinks = $(".navmenu-specialstyles li .wp-block-navigation-item__content");
        let lastKnownScrollPosition = 0;
        let ticking = false;
        const isHomePage = $("body").hasClass("home"); // Assuming 'home' class is added to body on homepage
        const HISTORY_DEBOUNCE_MS = 200;
        let historyUpdateTimer = null;
        let pendingHash = null;
        let lastHash = window.location.hash || "";
        const buildUrlWithHash = (hash)=>{
            const baseUrl = window.location.pathname + window.location.search;
            return hash ? `${baseUrl}${hash}` : baseUrl;
        };
        const setHistoryHash = (hash, { replace: replace = true, immediate: immediate = false } = {})=>{
            const normalizedHash = hash ? `#${hash.replace(/^#/, "")}` : "";
            if (normalizedHash === lastHash) return;
            if (immediate) {
                if (historyUpdateTimer) {
                    clearTimeout(historyUpdateTimer);
                    historyUpdateTimer = null;
                }
                pendingHash = null;
                const url = buildUrlWithHash(normalizedHash);
                if (replace) history.replaceState(null, "", url);
                else history.pushState(null, "", url);
                lastHash = normalizedHash;
                return;
            }
            pendingHash = normalizedHash;
            if (!historyUpdateTimer) historyUpdateTimer = setTimeout(function() {
                historyUpdateTimer = null;
                if (pendingHash === lastHash) return;
                const url = buildUrlWithHash(pendingHash);
                history.replaceState(null, "", url);
                lastHash = pendingHash;
            }, HISTORY_DEBOUNCE_MS);
        };
        window.addEventListener("popstate", function() {
            lastHash = window.location.hash || "";
        });
        // Function to get the current active section
        const getCurrentSection = (scrollPosition)=>{
            if (!isHomePage) return null;
            let currentSection;
            const viewportMiddle = scrollPosition + $(window).height() / 2;
            sections.each(function() {
                const sectionTop = $(this).offset().top;
                const sectionBottom = sectionTop + $(this).outerHeight();
                if (viewportMiddle >= sectionTop && viewportMiddle <= sectionBottom) {
                    currentSection = this;
                    return false; // Break the loop
                }
            });
            return currentSection;
        };
        // Function to update active link and URL
        const updateActiveLink = (scrollPosition)=>{
            const currentSection = getCurrentSection(scrollPosition);
            if (currentSection) {
                const id = $(currentSection).attr("id");
                const activeLink = navLinks.filter(`[href$="#${id}"]`);
                navLinks.removeClass("specialmenuactive");
                if (activeLink.length) {
                    activeLink.addClass("specialmenuactive");
                    // Update URL without triggering a page reload (debounced)
                    setHistoryHash(id, {
                        replace: true
                    });
                }
            } else {
                // If no section is active, remove all active classes and clear the hash
                navLinks.removeClass("specialmenuactive");
                setHistoryHash("", {
                    replace: true
                });
            }
        };
        // Handle scroll events
        if (isHomePage) $(window).on("scroll", function(e) {
            lastKnownScrollPosition = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    updateActiveLink(lastKnownScrollPosition);
                    ticking = false;
                });
                ticking = true;
            }
        });
        // Function to get the appropriate scroll offset
        const getScrollOffset = ()=>{
            if ($("body").hasClass("adminbar")) return 180;
            return 135;
        };
        // Handle navigation link clicks
        navLinks.on("click", function(e) {
            const href = $(this).attr("href");
            // Check if the link is to an anchor on the same page
            if (href.startsWith("#") || isHomePage && href.includes("#")) {
                e.preventDefault();
                // Extract the ID from the href, handling both /#example and #example formats
                const match = href.match(/#(.+)$/);
                if (match) {
                    const targetId = match[1];
                    const targetSection = $("#" + targetId);
                    if (targetSection.length) {
                        const offset = getScrollOffset();
                        const targetPosition = targetSection.offset().top - offset;
                        // Update URL immediately (user-initiated)
                        setHistoryHash(targetId, {
                            replace: false,
                            immediate: true
                        });
                        // Quick smooth scroll
                        $("html, body").animate({
                            scrollTop: targetPosition
                        }, 0, function() {
                            // Update active link after scrolling is complete
                            updateActiveLink(targetPosition);
                        });
                        // Close mobile menu if it's open
                        $(".wp-block-navigation__responsive-container.is-menu-open").removeClass("is-menu-open");
                        $("html").removeClass("has-modal-open");
                    } else console.warn(`Target section not found: #${targetId}`);
                }
            }
        // If it's not an anchor link or not on the homepage, let the default behavior occur
        });
        // Handle mobile menu
        const mobileToggle = $(".wp-block-navigation__responsive-container-open");
        const mobileClose = $(".wp-block-navigation__responsive-container-close");
        if (mobileToggle.length && mobileClose.length) {
            mobileToggle.on("click", function() {
                // Use the last known scroll position when opening the menu
                setTimeout(function() {
                    updateActiveLink(lastKnownScrollPosition);
                }, 50);
            });
            mobileClose.on("click", function() {
                // Use the last known scroll position when closing the menu
                setTimeout(function() {
                    updateActiveLink(lastKnownScrollPosition);
                }, 50);
            });
        }
        // Handle initial load with hash in URL
        if (isHomePage && window.location.hash) {
            const targetId = window.location.hash.substring(1);
            const targetSection = $("#" + targetId);
            if (targetSection.length) setTimeout(function() {
                const offset = getScrollOffset();
                const targetPosition = targetSection.offset().top - offset;
                // Smooth scroll to the target section
                $("html, body").animate({
                    scrollTop: targetPosition
                }, 0, function() {
                    updateActiveLink(targetPosition);
                });
            }, 100); // Small delay to ensure page is fully loaded
        }
        // Initial update
        if (isHomePage) updateActiveLink(window.scrollY);
    });
})(jQuery);


document.addEventListener("contextmenu", (event)=>{
    if (event.target.closest("img, picture, figure")) event.preventDefault();
});
document.addEventListener("dragstart", (event)=>{
    if (event.target.closest("img, picture, figure")) event.preventDefault();
});


 // Make anime available globally if needed
 // window.anime = anime;

})();
//# sourceMappingURL=bundle.js.map
